module.exports = __webpack_public_path__ + "static/media/card_svg.c0d48983.svg";